import type { RouteObjectEnhanced } from './type';
import { ENABLE_BUILDER_ANONYMOUS_MODE } from '@wegic/common';

/* 匿名模式开启时允许未登录访问的 workspace / 项目入口 */
const ANONYMOUS_FRIENDLY_PATHS = [
  /^\/workspace$/,
  /^\/workspace\/projects$/,
  /^\/projects$/,
  /^\/workspace\/projects\/[^/]+/,
  /^\/projects\/[^/]+/,
];

const PROJECT_ROUTE_PATH_PATTERN = /^\/(?:workspace\/)?projects(?:\/|$)/;

type RouteMatchWithRoute = Array<{ route: unknown }>;

export const LOGIN_REDIRECT_PARAM = 'redirect';

export function getLoginRedirect(searchParams: URLSearchParams) {
  return searchParams.get(LOGIN_REDIRECT_PARAM);
}

/** 嵌套路由任意一层声明 requireLogin 时，都视为需要登录 */
export function hasRequireLoginRoute(matches: RouteMatchWithRoute | null | undefined) {
  return matches?.some(({ route }) => (route as RouteObjectEnhanced).meta?.requireLogin) ?? false;
}

/** 构建登录页地址，并把原始路径完整写入 redirect 参数 */
export function buildLoginRedirectPath(pathname: string, search = '', hash = '') {
  const fullPath = `${pathname}${search}${hash}`;
  const searchParams = new URLSearchParams({ [LOGIN_REDIRECT_PARAM]: fullPath });
  return `/login?${searchParams.toString()}`;
}

/** 匿名项目模式是否已开启 */
export function isAnonymousProjectModeEnabled() {
  return ENABLE_BUILDER_ANONYMOUS_MODE;
}

/** 当前用户是否允许走匿名项目模式 */
export function canUseAnonymousProjectMode(isLogin: boolean) {
  return isAnonymousProjectModeEnabled() && !isLogin;
}

/** 当前路径是否属于匿名模式允许访问的项目入口 */
export function isAnonymousFriendlyPath(pathname: string) {
  return ANONYMOUS_FRIENDLY_PATHS.some(re => re.test(pathname));
}

/** 匿名模式开启时，项目入口允许绕过前置登录 */
export function canBypassLoginForAnonymousPath(pathname: string) {
  return isAnonymousProjectModeEnabled() && isAnonymousFriendlyPath(pathname);
}

/** 是否为当前或兼容的项目路由 */
export function isProjectRoutePath(pathname: string) {
  return PROJECT_ROUTE_PATH_PATTERN.test(pathname);
}
